export default "__VITE_ASSET__CwmPnYYw__"